export default "__VITE_ASSET__f5ae79d7__"